/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SubscriptionQuota interface.
 */
export function instanceOfSubscriptionQuota(value) {
    if (!('limit' in value) || value['limit'] === undefined)
        return false;
    if (!('remaining' in value) || value['remaining'] === undefined)
        return false;
    if (!('used' in value) || value['used'] === undefined)
        return false;
    return true;
}
export function SubscriptionQuotaFromJSON(json) {
    return SubscriptionQuotaFromJSONTyped(json, false);
}
export function SubscriptionQuotaFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'limit': json['limit'],
        'remaining': json['remaining'],
        'used': json['used'],
    };
}
export function SubscriptionQuotaToJSON(json) {
    return SubscriptionQuotaToJSONTyped(json, false);
}
export function SubscriptionQuotaToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'limit': value['limit'],
        'remaining': value['remaining'],
        'used': value['used'],
    };
}
